import type { FC } from 'react';
import type { LoadingIndicatorProps } from '@THC/components/LoadingIndicator';
import { LoadingIndicator } from '@THC/components/LoadingIndicator';

import styles from './PageLoadingIndicator.module.scss';

const PageLoadingIndicator: FC<LoadingIndicatorProps> = (props) => (
	<div className={styles.container}>
		<LoadingIndicator showText size="large" {...props} />
	</div>
);

export default PageLoadingIndicator;
